import React from 'react';
import {observer} from 'mobx-react';
import {ActionLink} from 'shared/components';
import { observable, makeObservable } from 'mobx';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';

const BalanceDetails = observer(({account}) => {
  if (account.unlimited) {
    return (
      <div>
        <div className='flex mt1'>
          <div style={{fontSize: 22}} className='TimeOffBalances-itemNumber tutarta mr1 col-2'>{'--'}</div>
          <div className='TimeOffBalances-itemTitle align-self-end col-10'>
            <FormattedMessage id={`employees.profile.time_off.${_.startCase(account.timeOffType.unit)} Available`}/>
          </div>
        </div>
        <div className='flex mt1'>
          <div style={{fontSize: 22, minWidth: '16.6666667%'}} className='TimeOffBalances-itemNumber tutarta mr1'>{account.logged}</div>
          <div className='TimeOffBalances-itemTitle align-self-end'>
            <FormattedMessage id={`employees.profile.time_off.${_.startCase(account.timeOffType.unit)} Logged`}/>
          </div>
        </div>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className={`TimeOffBalances-itemNumber ${account.isNegativeBalance ? 'scarlet' : 'tuatara'}`}>{account.balanceView}</div>
      <div className='TimeOffBalances-itemTitle'>
        <FormattedMessage id={account.balanceDescription}/>
      </div>
    </React.Fragment>
  );
});

const Item = observer(({uiState, account}) => {
  return (
    <div
      className='TimeOffBalances-item'
      onClick={() => uiState.openPolicySummaryModal(account)}
    >
      <div className='TimeOffBalances-typeName'>
        <div className='table-cell align-middle'>{account.timeOffType.name}</div>
      </div>
      <BalanceDetails account={account}/>
    </div>
  );
});

class TimeOffBalances extends React.Component {
  showScrolling = false;
  scrolling = null;

  constructor(props) {
    super(props);

    makeObservable(this, {
      showScrolling: observable,
      scrolling: observable
    });
  }

  componentDidMount() {
    const {accounts} = this.props.uiState;
    const width = this.container.getBoundingClientRect().width;
    if (accounts.length * 225 > width) {
      this.showScrolling = true;
    }
  }

  scrollLeft = (e) => {
    e.preventDefault();
    const container = this.container;
    const scrolling = setInterval(function() {
      container.scrollLeft -= 15;
    }, 26);

    this.scrolling = scrolling;
  };

  scrollRight = (e) => {
    e.preventDefault();
    const container = this.container;
    const scrolling = setInterval(function() {
      container.scrollLeft += 15;
    }, 26);

    this.scrolling = scrolling;
  };

  clearScrolling = () => {
    clearInterval(this.scrolling);
  };

  render() {
    const {uiState} = this.props;
    const {scrollLeft, scrollRight, clearScrolling, showScrolling} = this;

    return (
      <div className='TimeOffBalances'>
        {showScrolling && <ActionLink className='TimeOffBalances-scroll--left jumbo' onMouseEnter={scrollLeft} onMouseLeave={clearScrolling}><i className='material-icons'>{'keyboard_arrow_left'}</i></ActionLink>}
        <div className='TimeOffBalances-carousel' ref={container => this.container = container}>
          {uiState.accounts.map(account => <Item key={account.id} account={account} uiState={uiState}/>)}
        </div>
        {showScrolling && <ActionLink className='TimeOffBalances-scroll--right jumbo' onMouseEnter={scrollRight} onMouseLeave={clearScrolling}><i className='material-icons'>{'keyboard_arrow_right'}</i></ActionLink>}
      </div>
    );
  }
}

export default observer(TimeOffBalances);
